import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/stable';
// import 'react-app-polyfill/ie11'; // For IE 11 support
import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import AlertTemplate from 'react-alert-template-basic'
import { transitions, positions, types, Provider as AlertProvider } from 'react-alert'


const alertOptions = {
  // you can also just use 'bottom center'
  position: positions.TOP_RIGHT,
  timeout: 3000,
  offset:"10px",
  type: types.SUCCESS,
  transition: transitions.SCALE,
  containerStyle: {
    marginTop:"50px",
    zIndex: 2000
  }
}
const Root = () => (
  <AlertProvider template={AlertTemplate} {...alertOptions}>
    <App />
  </AlertProvider>
)
ReactDOM.render(<Root />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
